(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/init-lb/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/components/casino-react/init-lb/assets/javascripts/init.js');
"use strict";


const {
  render
} = ReactDOM;
const RouterRoot = svs.components.casino_react.root.Root;
const {
  ErrorBoundary
} = svs.components.errorBoundary;
const LbNavMenu = svs.components.casino_react.lbNavMenu;
const {
  CampaignFlerp
} = svs.components.lbUi.campaignFlerp;
const App = () => React.createElement("div", {
  className: "theme-lb-casino"
}, React.createElement(CampaignFlerp, null), React.createElement(LbNavMenu, null), React.createElement(React.StrictMode, null, React.createElement(ErrorBoundary, null, React.createElement(RouterRoot, null))));
const init = appRoot => {
  if (appRoot) {
    if (svs.core.detect.formfactor.mobile()) {
      if (svs.core.detect.feature('ft-floating-swish-buttons')) {
        new svs.casino.quick_transaction.TransactionButtons();
      }
    }
    render(React.createElement(App, null), appRoot);
  }
};
const appRoot = document.getElementById('casino-search');
init(appRoot);
setGlobal('svs.components.casino_react.initLb', {
  init,
  App
});

 })(window);